import { Box, Button, Container, Typography, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { Trans } from "react-i18next";
import { t } from "i18next";

// import { useTranslation } from "react-i18next"; // Import useTranslation hook

const ServiceUnavailable = () => {
  const theme = useTheme();
  // const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        textAlign: "center",
        maxWidth: 600,
        mx: "auto",
        p: 3,
      }}
    >
      {/* Status Code */}
      <Box
        sx={{
          display: "flex",
          alignItems: "end",
          gap: 1, // Adjust the gap between the two Typography components
        }}
      >
        <MDTypography
          variant="h1"
          sx={{
            fontSize: "6rem",
            fontWeight: 700,
            color: "info",
            [theme.breakpoints.down("sm")]: {
              fontSize: "4rem",
            },
          }}
        >
          503
        </MDTypography>
        <MDTypography
          variant="h5"
          sx={{
            fontWeight: 400,
            color: "info",
            mb: 3,
            [theme.breakpoints.down("sm")]: {
              fontSize: "1.5rem",
            },
          }}
        >
          Service unavailable
        </MDTypography>
      </Box>
      {/* Title */}
      <MDTypography
        variant="h4"
        component="h2"
        sx={{
          fontWeight: 600,
          color: "info",
          mb: 2,
          [theme.breakpoints.down("sm")]: {
            fontSize: "1.75rem",
          },
        }}
      >
        {t("serviceUnavailable.title")} {/* Translated title */}
      </MDTypography>

      {/* Description */}
      <MDTypography
        variant="body1"
        sx={{
          color: theme.palette.text.secondary,
          mb: 4,
          fontSize: "1.1rem",
          lineHeight: 1.6,
        }}
      >
        {t("serviceUnavailable.description")} {/* Translated description */}
      </MDTypography>

      {/* Action Buttons */}
      <MDBox sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
        <MDButton
          variant="contained"
          color="info"
          onClick={() => window.location.reload()}
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: 2,
            fontWeight: 600,
            textTransform: "none",
            fontSize: "1rem",
          }}
        >
          {t("serviceUnavailable.tryAgain")} {/* Translated button text */}
        </MDButton>

        <MDButton
          component={RouterLink}
          to="/"
          variant="outlined"
          color="dark"
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: 2,
            fontWeight: 600,
            borderWidth: 2,
            textTransform: "none",
            fontSize: "1rem",
            "&:hover": {
              borderWidth: 2,
            },
          }}
        >
          {t("serviceUnavailable.returnHome")}
        </MDButton>
      </MDBox>

      {/* Contact Information */}
      <MDTypography
        variant="body2"
        sx={{
          color: theme.palette.text.secondary,
          mt: 4,
          fontSize: "0.9rem",
        }}
      >
        <Trans
          i18nKey="serviceUnavailable.contactInfo"
          components={{ strong: <strong style={{ color: "black", fontWeight: "bold" }} /> }}
        />
      </MDTypography>
    </Box>
  );
};

export default ServiceUnavailable;
